import { render, staticRenderFns } from "./exhibitor.vue?vue&type=template&id=5430de60&scoped=true&"
import script from "./exhibitor.vue?vue&type=script&lang=js&"
export * from "./exhibitor.vue?vue&type=script&lang=js&"
import style0 from "./exhibitor.vue?vue&type=style&index=0&id=5430de60&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5430de60",
  null
  
)

export default component.exports